import { useState } from "react";

export default function TableBus({
  busType,
  seats,
  changeSeats,
  limit,selected, setSelected
}) {
  const [refresher, setRefresher] = useState(false);

  const selectSeat = (index) => {
    if (seats[index] != 2) {
      let value = 3;
      if (seats[index] == 3) {
        value = 1;
        setSelected(selected - 1);
      } else {
        if (limit <= selected) return;
        setSelected(selected + 1);
      }
      changeSeats(
        seats.map((val, i) => {
          if (index == i) {
            return value;
          }
          return val;
        })
      );
      setRefresher(!refresher);
    }
  };

  var counter = 0;
  const chair = (index = -1) => {
    if (index === -1) {
      counter++;
      return <div className={`the-chair type0`} key={46 + counter}></div>;
    }
    return (
      <div
        className={`the-chair type${seats[index]}`}
        key={index}
        onClick={() => selectSeat(index)}
      >
        {index + 1}
      </div>
    );
  };

  return (
    <div className="mt-3 the-bus-sit">
      {busType == 1 ? (
        <div>
          <div className="chair-container">
            {chair(22)}
            {chair(19)}
            {chair(16)}
            {chair(13)}
            {chair()}
            {chair(9)}
            {chair(6)}
            {chair(3)}
            {chair(0)}
          </div>
          <div className="chair-container">
            {chair(23)}
            {chair(20)}
            {chair(17)}
            {chair(14)}
            {chair()}
            {chair(10)}
            {chair(7)}
            {chair(4)}
            {chair(1)}
          </div>
          <div className="chair-container">
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
          </div>
          <div className="chair-container">
            {chair(24)}
            {chair(21)}
            {chair(18)}
            {chair(15)}
            {chair(12)}
            {chair(11)}
            {chair(8)}
            {chair(5)}
            {chair(2)}
          </div>
        </div>
      ) : busType == 2 ? (
        <div>
          <div className="chair-container">
            {chair(40)}
            {chair(36)}
            {chair(32)}
            {chair(28)}
            {chair(24)}
            {chair()}
            {chair()}
            {chair(16)}
            {chair(12)}
            {chair(8)}
            {chair(4)}
            {chair(0)}
          </div>
          <div className="chair-container">
            {chair(41)}
            {chair(37)}
            {chair(33)}
            {chair(29)}
            {chair(25)}
            {chair()}
            {chair()}
            {chair(17)}
            {chair(13)}
            {chair(9)}
            {chair(5)}
            {chair(1)}
          </div>
          <div className="chair-container">
            {chair(42)}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
            {chair()}
          </div>
          <div className="chair-container">
            {chair(43)}
            {chair(38)}
            {chair(34)}
            {chair(30)}
            {chair(26)}
            {chair(22)}
            {chair(20)}
            {chair(18)}
            {chair(14)}
            {chair(10)}
            {chair(6)}
            {chair(2)}
          </div>
          <div className="chair-container">
            {chair(44)}
            {chair(39)}
            {chair(35)}
            {chair(31)}
            {chair(27)}
            {chair(23)}
            {chair(21)}
            {chair(19)}
            {chair(15)}
            {chair(11)}
            {chair(7)}
            {chair(3)}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
